import React from 'react';
import PropTypes from 'prop-types';
import RcTreeSelect from 'rc-tree-select';
import { SHOW_PARENT } from 'rc-tree-select';

function TreeSelect(selectProps) {
  const treeCheckable = selectProps.treeCheckable || true;
  const prefixCls = selectProps.prefixCls || 'hfish-tree-select';
  return (
    <RcTreeSelect
      dropdownPopupAlign={{
        overflow: { adjustY: 0, adjustX: 0 },
        offset: [0, 2]
      }}
      // treeCheckable={
      //   treeCheckable ? <span className={`${prefixCls}-tree-checkbox-inner`} /> : treeCheckable
      // }
      treeCheckable={true}
      treeNodeFilterProp="title"
      showCheckedStrategy={SHOW_PARENT}
      prefixCls={prefixCls}
      {...selectProps}
    />
  );
}

TreeSelect.defaultProps = {
  type: 'table'
};
TreeSelect.propTypes = {
  /** 要展示的类型 */
  data: PropTypes.string
};

export default TreeSelect;
